export default __webpack_public_path__ + "static/presse-fest-oberaudorf-1-preview-4962d538fe52e349139437cf8b6dbecc.jpg";